import React, { useState, useEffect } from "react";
import {
  Input,
  Form,
  Col,
  Row,
  Button,
  Select,
  Collapse,
  DatePicker,
  InputNumber,
} from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { odata } from "./Helper";
import moment from "moment";
const { Option } = Select;

const InvoiceTableFilter = (props) => {
  const [form] = Form.useForm();
  const [productTypeSelect, setProductTypeSelect] = useState({
    data: [],
    loading: true,
  });
  const [invoiceSelect, setInvoiceSelect] = useState({
    data: [],
    loading: false,
  });

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  useEffect(() => {
    RequestHandler.get(`/Invoice/GetProductTypes`).then((response) => {
      setProductTypeSelect({
        data: response,
        loading: false,
      });
    });
  }, []);

  const onInvoiceSearch = (value) => {
    if (value.length >= 2) {
      setInvoiceSelect({
        ...invoiceSelect,
        loading: true,
      });
      RequestHandler.get(
        `/Invoice?$select=id,product&$filter=${odata.contains(
          "product",
          value
        )}`
      ).then((res) => {
        if (res.value) {
          setInvoiceSelect({ data: res.value, loading: false });
        }
      });
    } else {
      setInvoiceSelect({ ...invoiceSelect, data: [] });
    }
  };
  const onFinish = (values) => {
    {
      let query = "";
      const conditions = [];

      if (values.productType) {
        conditions.push(`productTypeId eq ${values.productType}`);
      }

      if (values.product) {
        conditions.push(`Contains(product,'${values.product}')`);
      }

      if (values.subscriberNo) {
        conditions.push(`Contains(subscriberNo,'${values.subscriberNo}')`);
      }

      if (values.invoiceTerm) {
        let formatedDate = moment(values.invoiceTerm).format("MM/yyyy");
        formatedDate =
          formatedDate.charAt(0) == "0"
            ? formatedDate.substring(1)
            : formatedDate;
        conditions.push(`invoiceTerm eq '${formatedDate}'`);
      }
      if (values.amountMin) {
        conditions.push(`amount Ge ${values.amountMin}`);
      }

      if (values.amountMax) {
        conditions.push(`amount Le ${values.amountMax}`);
      }

      if (values.totalMin) {
        conditions.push(`total Ge ${values.totalMin}`);
      }

      if (values.totalMax) {
        conditions.push(`total Le ${values.totalMax}`);
      }
      if (values.referenceNumber) {
        conditions.push(
          `Contains(referenceNumber,'${values.referenceNumber}')`
        );
      }
      if (values.invoiceStatusId) {
        conditions.push(`invoiceStatusId eq ${values.invoiceStatusId}`);
      }

      if (conditions.length !== 0) {
        query = conditions.join(" and ");
      }
      if (props.onFinishFilter) props.onFinishFilter(query);

      if (query) {
        query = "$filter=" + query;
      }
    }
  };

  const clearFilter = () => {
    form.resetFields();
    setInvoiceSelect({ data: [] });

    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  return (
    <>
      <Row id="filterArea" style={{ ...props.style }}>
        <Col span={24}>
          <Collapse>
            <Collapse.Panel header="Filtreleme için tıklayınız.">
              <Form
                name="filter"
                form={form}
                initialValues={{
                  remember: true,
                }}
                layout="vertical"
                onFinish={onFinish}
              >
                <Row style={{ flexDirection: "row" }}>
                  <Col xs={24} md={12} lg={6}>
                    <Form.Item name="product" label="Kurum Adı :">
                      <Input placeholder="Kurum Adı" />
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={12} lg={6}>
                    <Form.Item name="productType" placeholder="Kurum Tipi" label="Kurum Tipi :">
                      <Select
                        name="productTypes"
                        style={{ width: "100%" }}
                        loading={false}
                        placeholder="Kurum Tipi"
                      >
                        {productTypeSelect.data.map((item, index) => (
                          <Option key={item.id} value={index}>
                            {item.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={12} lg={6}>
                    <Form.Item name="subscriberNo" placeholder="Abone No" label="Abone No :">
                      <Input placeholder="Abone No" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} lg={6}>
                    <Form.Item name="invoiceTerm" placeholder="Fatura Dönemi" label="Fatura Dönemi">
                      <DatePicker
                        picker="month"
                        style={{
                          width: "100%",
                        }}
                      ></DatePicker>
                    </Form.Item>
                  </Col>
                </Row>
                <Row style={{ flexDirection: "row" }}>
                  <Col xs={24} md={12} lg={6}>
                    <Form.Item label="Fatura Tutarı">
                      <Input.Group>
                        <Row gutter={1} style={{ flexDirection: "row" }}>
                          <Col span={12}>
                            <Form.Item name="amountMin">
                              <InputNumber min={0} style={{ width: "100%" }} placeholder="Başlangıç" />
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item name="amountMax">
                              <InputNumber min={0} style={{ width: "100%" }} placeholder="Bitiş" />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Input.Group>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} lg={6}>
                    <Form.Item name="total" label="Toplam Tutar">
                      <Input.Group>
                        <Row gutter={1} style={{ flexDirection: "row" }}>
                          <Col span={12}>
                            <Form.Item name="totalMin">
                              <InputNumber min={0} style={{ width: "100%" }} placeholder="Başlangıç" />
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item name="totalMax">
                              <InputNumber min={0} style={{ width: "100%" }} placeholder="Bitiş" />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Input.Group>
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} lg={6}>
                    <Form.Item name="referenceNumber" label="Referans Numarası">
                      <Input placeholder="Referans Numarası" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12} lg={6}>
                    <Form.Item name="invoiceStatusId" placeholder="Fatura Durumu" label="Fatura Durumu :">
                      <Select
                        allowClear
                        placeholder="Tümü"
                        filterOption={(input, option) =>
                          option.props.children
                            .toLocaleLowerCase("tr-TR")
                            .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                        }
                      >
                        {[
                          { id: 1, name: "Başarılı" },
                          { id: 2, name: "Başarısız" },
                        ].map((item) => (
                          <Select.Option key={item.id} value={item.id}>
                            {item.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row style={{ flexDirection: "row" }}>
                  <Col span={24} style={{ textAlign: "right" }}>
                    <Button
                      danger
                      size="small"
                      icon={<CloseOutlined />}
                      onClick={() => clearFilter()}
                    >
                      Sıfırla
                    </Button>
                    <Button
                      type="primary"
                      size="small"
                      icon={<SearchOutlined />}
                      style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                      htmlType="submit"
                    >
                      Filtrele
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Collapse.Panel>
          </Collapse>
        </Col>
      </Row>
    </>
  );
};
export default InvoiceTableFilter;
